
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/work/dashboard/dashboard/sentry.client.config.ts")
            }
          });